import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Arrow } from 'components/CommonIcons';

import * as styles from './ColumnSeekerHeaderRowRenderer.scss';

/**
 * Reusable ColumnSeekerHeaderRowRenderer Component -- Manages Current Viewed Columns and Renders Arrows to Click
 * @ColumnSeekerHeaderRowRenderer
 * @param {Object} props
 * @return {ReactElement}
 */
const ColumnSeekerHeaderRowRenderer = ({
  className,
  columnCount,
  columnRange,
  columns,
  handleColumnSeek,
  stickyIndexes,
  style,
}) => {
  const isArrowDisabled = useCallback(
    index => index === 0 ? columnRange[0] === stickyIndexes.length : columnRange[1] > columnCount,
    [columnCount, columnRange, stickyIndexes],
  );
  const handleColumnBack = useCallback(
    () => isArrowDisabled(0) ? null : handleColumnSeek([columnRange[0] - 1, columnRange[1] - 1]),
    [columnRange],
  );
  const handleColumnForward = useCallback(
    () => isArrowDisabled(1) ? null : handleColumnSeek([columnRange[0] + 1, columnRange[1] + 1]),
    [columnRange],
  );

  return (
    <div className={className} role="row" style={style}>
      {columns}
      <div className={styles.container}>
        <div className={styles.arrowContainer}>
          <div className={styles.arrowItem} onClick={handleColumnBack} style={{ marginRight: '-8px' }}>
            <Arrow
              className={classNames(
                styles.arrow,
                styles.arrowLeft,
                { [styles.arrowDisabled]: isArrowDisabled(0) }
              )}
              color={isArrowDisabled(0) ? '#AFC1E1' : '#105EEB'} />
          </div>
          <div className={styles.arrowItem} onClick={handleColumnForward}>
            <Arrow
              className={classNames(
                styles.arrow,
                styles.arrowRight,
                { [styles.arrowDisabled]: isArrowDisabled(1) }
              )}
              color={isArrowDisabled(1) ? '#AFC1E1' : '#105EEB'} />
          </div>
        </div>
      </div>
    </div>
  );
};

ColumnSeekerHeaderRowRenderer.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  columnCount: PropTypes.number.isRequired,
  columnRange: PropTypes.arrayOf(
    PropTypes.number,
  ).isRequired,
  handleColumnSeek: PropTypes.func.isRequired,
  stickyIndexes: PropTypes.arrayOf(
    PropTypes.number,
  ).isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  ),
};

export default ColumnSeekerHeaderRowRenderer;
